<h1 class="mb-3">Add Donation to Batch</h1>

<p-card>
  <div class="grid">
    <!-- Left: Text Info -->
    <div class="col-12 md:col-6 batch-info-labels">
      <div class="mb-2"><strong>Campaign:</strong> {{ headerInfo.campaign }}</div>
      <div class="mb-2"><strong>Fund Code:</strong> {{ headerInfo.fundCode }}</div>
      <div class="mb-3">
        <strong>Batch Name:</strong>
        <a [routerLink]="headerInfo.batchLink" class="text-primary">
          {{ headerInfo.batchName }}
        </a>
      </div>

      <button pButton label="Complete Batch" (click)="completeBatch()" class="p-button" data-cy="btn-complete-batch"></button>
    </div>

    <!-- Right: Summary Table -->
    <div class="col-12 md:col-6">
      <table class="summary-table">
        <thead>
          <tr>
            <th></th>
            <th>Donations</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr data-cy="row-entered">
            <td><strong>Entered</strong></td>
            <td>
              <span [ngClass]="getBadgeDonationCountClass()">{{ headerInfo.entered }}</span>
            </td>
            <td>
              <span [ngClass]="getBadgeDonationAmountClass()">${{ headerInfo.amount | number: '1.0-2' }}</span>
            </td>
          </tr>
          <tr data-cy="row-remaning">
            <td><strong>Remaining</strong></td>
            <td>{{ headerInfo.remaining }}</td>
            <td>${{ headerInfo.remainingAmount | number:'1.0-2' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</p-card>
